module.exports = __webpack_public_path__ + "img/2.6cfea9e2.png";